import { render, staticRenderFns } from "./TerminalLayout.vue?vue&type=template&id=04b3cc6c&scoped=true"
import script from "./TerminalLayout.vue?vue&type=script&lang=js"
export * from "./TerminalLayout.vue?vue&type=script&lang=js"
import style0 from "./TerminalLayout.vue?vue&type=style&index=0&id=04b3cc6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3cc6c",
  null
  
)

export default component.exports